export default {"src":"/_next/static/media/tahap.1dc79787.svg","height":610,"width":1216,"blurWidth":0,"blurHeight":0};